<template>
  <div class="ding-invite" v-if="visible">
    <div class="hui-alert" v-if="!infoVisible">
      <div>
        <van-icon name="info-o" class="icon"/>
        <span class="message">邀请同事或申请管理员授权更多人试用</span>
        <span class="action" @click="showInfo">查看</span>
      </div>
      <div class="close-wrp" @click="clickClose">
        <van-icon name="cross" class="close"/>
      </div>
    </div>
    <div v-else class="info-wrp">
      <div class="info">
        <p class="title">
          <span class="title-text">邀请同事试用</span>
          <van-icon name="cross" class="close" @click="clickClose"/>
        </p>
        <p class="content">可邀请同事或请管理员进行更大范围授权使用。</p>
        <p class="btn">
          <span @click="invite">邀请同事</span>
          <span @click="adminEmpower">管理员授权</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant'
import { inviteToUseApp, contactAdminToUseApp } from 'dingtalk-design-libs'
export default {
  components: {
    [Icon.name]: Icon
  },
  props: {},
  data () {
    return {
      visible: true,
      infoVisible: false
    }
  },
  computed: {
  },
  watch: {},
  created () {},
  mounted () {
  },
  activated () {},
  updated () {},
  methods: {
    clickClose () {
      this.visible = false
    },
    showInfo () {
      this.infoVisible = true
    },
    invite () {
      let { appId, mainCropId } = this.$store.state.user.dingConfig || {}
      inviteToUseApp({
        id: appId, // 应用appId
        corpId: mainCropId // 当前组织的corpId,这里需要传主企业的corpId
      })
        .catch((err) => {
          // 入参不正确，或者遇到技术异常时才会进入这个链路
          console.error(err)
        })
    },
    adminEmpower () {
      let { appId, mainCropId } = this.$store.state.user.dingConfig || {}
      contactAdminToUseApp({
        id: appId, // 应用appId
        corpId: mainCropId, // 当前组织的corpId，这里需要传主企业的corpId
        type: 'INVITE' // 接入成员授权必传参数
      })
        .catch((err) => {
          // 入参不正确，或者遇到技术异常时才会进入这个链路
          console.error(err)
        })
    }
  }
}
</script>
<style scoped lang='less'>
.ding-invite{
  .hui-alert{
    width: 100%;
    // margin: 8px;
    box-sizing: border-box;
    padding: 20px 20px;
    border: 1px solid #91d5ff;
    background: rgb(230, 247, 255);
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .icon{
      color: rgb(24, 144, 255);
    }
    .message{
      color: rgba(0,0,0,.85);
      margin-left: 16px;
    }
    .action{
      color: #297CF0;
      margin-left: 16px;
    }
    .close-wrp{
      width: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .close{
        color: rgba(0,0,0,.45);
        justify-self: flex-end;
      }
    }
  }
  .info-wrp{
    padding: 24px 30px;
    background: #eee;
    .info{
      border-radius: 16px;
      background: #D4E3F7;
      padding: 24px 35px;
      background-color: #D4E3F7;
      background-image: url('../../assets/img/bannerImg.png');
      background-size: 100% 100%;
    }
    .title{
      display: flex;
      align-content: center;
      justify-content: space-between;
      .title-text{
        font-size: 37px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: bold;
        color: #191B1E;
        line-height: 52px;
      }
      .close{
        color: rgba(0,0,0,.45);
      }
    }
    .content{
      width: 60%;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #646C74;
      line-height: 36px;
      margin-top: 15px;
    }
    .btn{
      font-size: 31px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #2091FF;
      line-height: 44px;
      margin-top: 26px;
      span{
        margin-right: 36px;
      }
    }
  }
}
</style>
